import { Outlet, Link } from 'react-router-dom';
import { Nav } from '../components/Nav.jsx';

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-line mt-16 md:mt-24">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 grid md:grid-cols-3 gap-8 md:gap-6">
          <div>
            <div className="font-display text-2xl leading-none">Blaze</div>
            <div className="eyebrow text-brand mt-1">R.F.C. · Est. 2026</div>
            <p className="text-sm text-ink-2 mt-4 max-w-xs leading-relaxed">
              A rugby club for every level — senior, social, and everything in between.
            </p>
          </div>
          <div>
            <div className="eyebrow mb-3">Club</div>
            <ul className="space-y-2 text-sm text-ink-2">
              <li><Link to="/schedule" className="hover:text-ink">Schedule</Link></li>
              <li><Link to="/join" className="hover:text-ink">Join</Link></li>
              <li><Link to="/rent" className="hover:text-ink">Rent clubhouse</Link></li>
              <li><Link to="/shop" className="hover:text-ink">Shop</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-3">Contact</div>
            <ul className="space-y-2 text-sm text-ink-2">
              <li>clubhouse@blazerfc.com</li>
              <li>(555) 010–0000</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-line">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 flex items-center justify-between text-xs text-ink-3">
            <span>© {new Date().getFullYear()} Blaze Rugby Football Club</span>
            <span className="font-display italic">Fortis · Fidelis</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
